import { proxy } from "valtio";
import {Note} from "@models/note.model.ts";


export type NotebookCampaign = { id: number; name: string | null };

export const notebookStore = proxy<{
    selectedNote: Note;
    noteRefreshKey: number;
    pendingNote: Note | null;
    showNewFromTemplate: boolean;
    /** The campaigns a note can be filed against (MPN-1640). Loaded with the notebook,
     *  so the pop-out window has them too -- it knows the notebook id and nothing else. */
    campaigns: NotebookCampaign[];
}>({
    selectedNote: new Note(),
    noteRefreshKey: 0,
    pendingNote: null,
    showNewFromTemplate: false,
    campaigns: [],
});


